import type { SVGProps } from "react";
const SvgNotion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 256 256"
    {...props}
  >
    <rect width="100%" height="100%" fill="#fff" />
    <path
      fill="#fff"
      d="m30.956 22.009 128.341-9.482c15.765-1.352 19.815-.44 29.728 6.767l40.969 28.868C236.75 53.126 239 54.479 239 59.884v158.321c0 9.922-3.602 15.792-16.213 16.687l-149.037 9.03c-9.464.447-13.97-.905-18.927-7.222l-30.169-39.24C19.243 190.238 17 184.832 17 178.513V37.784c0-8.112 3.602-14.877 13.956-15.775"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M159.296 12.53 30.956 22.01C20.602 22.907 17 29.674 17 37.785v140.729c0 6.317 2.243 11.723 7.654 18.947l30.169 39.238c4.956 6.317 9.463 7.672 18.926 7.222l149.038-9.025c12.602-.897 16.213-6.767 16.213-16.687V59.887c0-5.127-2.025-6.605-7.986-10.98l-41.99-29.613c-9.911-7.208-13.963-8.12-29.728-6.767zM77.119 57.295c-12.17.819-14.93 1.004-21.842-4.617l-17.572-13.98c-1.786-1.81-.888-4.067 3.612-4.517l123.376-9.018c10.361-.905 15.756 2.707 19.808 5.862l21.16 15.336c.904.457 3.154 3.155.447 3.155L78.696 57.189zm-14.188 159.56V82.453c0-5.87 1.803-8.577 7.197-9.031l146.341-8.57c4.964-.448 7.207 2.707 7.207 8.567v133.508c0 5.869-.905 10.834-9.007 11.282l-140.039 8.12c-8.101.448-11.696-2.251-11.696-9.473zM201.168 89.659c.898 4.06 0 8.12-4.059 8.584l-6.749 1.339v99.232c-5.861 3.155-11.256 4.958-15.765 4.958-7.207 0-9.007-2.258-14.404-9.018l-44.138-69.46v67.203l13.963 3.162s0 8.12-11.266 8.12l-31.057 1.802c-.904-1.809 0-6.317 3.148-7.215l8.11-2.25v-88.855l-11.255-.912c-.905-4.06 1.345-9.922 7.654-10.377l33.323-2.244 45.924 70.358v-62.245l-11.706-1.345c-.905-4.972 2.697-8.584 7.197-9.025z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNotion;
